module.exports = __webpack_public_path__ + "img/icon_mailopen_mobile.fb7841c4.svg";